import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

import VerticalStepper from "./lib/VerticalStepper";
import FatcaDetails from "./FatcaDetails";
import SchemeDetails from "./SchemeDetails";
import InvestorDetails from "./InvestorDetails";
import Signbutton from "../../../forms/button";
import { NEW_TRANSACTION_URL } from "..";
import NomineeDetails from "./NomineeDetails";
import BankDetails from "./BankDetails";

const NewInvestorRegistration = (props) => {
  const { location } = props;
  const { pathname } = location;
  const activestep = pathname.split("/").slice(-1)[0];
  const hide = pathname.includes("first-time-new-investor-journey");
  return (
    <div className="digital-form-container-new-investor-jounrney ">
      <div className="digital-form-left-div" style={{ paddingRight: "20px" }}>
        <VerticalStepper active={activestep} hide={hide} location={location} />
      </div>
      <div className="digital-form-Right-div-investor-flow">
        <Switch>
          <Route
            exact
            path={"/new-investor-transaction/investor-details"}
            component={InvestorDetails}
            location={location}
          />
          <Route
            exact
            path={"/new-investor-transaction/fatca-details"}
            component={FatcaDetails}
            location={location}
          />
          <Route
            exact
            path={"/new-investor-transaction/nominee-details"}
            component={NomineeDetails}
            location={location}
          />
          <Route
            exact
            path={"/new-investor-transaction/bank-details"}
            component={BankDetails}
            location={location}
          />
          <Route
            exact
            path={"/new-investor-transaction/scheme-details"}
            component={SchemeDetails}
            location={location}
          />
        </Switch>
      </div>
    </div>
  );
};

export default connect(null)(NewInvestorRegistration);
